// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"

// Services
import UserService from "@/app/services/main/user/user-service"
import breederService from "@/app/services/main/breeder/breeder-service.js";


// Constants
import { STATUS_CODES, USER_ROLE, USER_TYPE } from "@/app/constants/constants"

export default {
	name: "UserComponent",
	mixins: [tableMixins, toastMessageMixins],
	props: {
		userFilter: {
			type: String,
			default: "",
		},
	},
	data() {
		const statusList = [
			{ name: "ACTIVE", value: "ACTIVE" },
			{ name: "INACTIVE", value: "INACTIVE" },
			{ name: "PENDING", value: "PENDING" },
			{ name: "REMOVED", value: "REMOVE" },
			{ name: "WAITING", value: "WAITING" },
		]
		const roleList = [
			{ name: "CUSTOMER", value: "CUST" },
			{ name: "WALKER", value: "WALK" },
			{ name: "SITTER", value: "SITT" },
			{ name: "WALKER AND SITTER", value: "WASI" },
			{ name: "BREEDER", value: "BRDER" },
		]

		return {
			walkerSitterCodeList: ["WALK", "SITT",  "WASI"],
			// table
			theads: [
				{
					name: "Email",
					searchLabel: "f_emailAddress",
					sortLabel: "emailAddress",
					isDesc: false,
					hasSearch: true,
					style: null,
				},
				{
					name: "First Name",
					searchLabel: "f_firstName",
					sortLabel: "firstName",
					isDesc: false,
					hasSearch: true,
					style: null,
				},
				{
					name: "Last Name",
					searchLabel: "f_lastName",
					sortLabel: "lastName",
					isDesc: false,
					hasSearch: true,
					style: null,
				},
				{
					name: "Role",
					sortLabel: "role",
					isDesc: false,
					searchLabel: "f_role",
					hasSearchableDropdown: true,
					optionList: roleList,
					style: "min-width: 200px",
				},
				{
					name: "Status",
					sortLabel: "status",
					isDesc: false,
					searchLabel: "f_status",
					hasSearchableDropdown: true,
					optionList: statusList,
					style: "max-width: 140px",
				},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null },
			],
			// sorting
			sortBy: "",
			desc: true,
			// filter
			isAPILoading: false,
			filterUserStatus: "",
			preFilterMode: !!this.userFilter,
			fromSubscription: this.$store.getters.getFromSubscription,
		}
	},
	watch: {
		filterUserStatus() {
			this.getTableContent(true)
		},
	},
	async created() {
		this.getTableContent()
	},
	mounted() {
		// Show owner filter on column text input
		if (this.userFilter && this.$refs.filter_emailAddress[0]) {
			this.$refs.filter_emailAddress[0].value = this.userFilter
		}
	},
	async beforeDestroy() {
		this.$emit("clearUserFilters")
	},
	methods: {
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page
			this.getUsers({ page, limit, sortBy, desc })
		},
		getUsers(queryParams) {
			// default filter
			queryParams["f_role"] = USER_ROLE.ALL_CUST //USER_ROLE.USER;

			// search dropdown filters
			if (this.columnsFilter) {
				const { f_status, f_role } = this.columnsFilter

				if (f_status) {
					queryParams["f_status"] = f_status
				}

				if (f_role) {
					queryParams["f_role"] = f_role
				}
			}

			// search filters
			if (this.columnsFilter) {
				if (this.columnsFilter.f_emailAddress) {
					queryParams["f_emailAddress"] = this.columnsFilter.f_emailAddress
				}
				if (this.columnsFilter.f_firstName) {
					queryParams["f_firstName"] = this.columnsFilter.f_firstName
				}
				if (this.columnsFilter.f_lastName) {
					queryParams["f_lastName"] = this.columnsFilter.f_lastName
				}
			}

			// Only called when the component is created and has owner filters.
			if (this.preFilterMode) {
				queryParams["f_emailAddress"] = this.userFilter
				this.preFilterMode = false
			}

			this.isAPILoading = true

			UserService.getUserList(queryParams).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.tableContent = {
						tableData: res.data.data,
						paginationData: res.data.pagination,
					}

					if (this.fromSubscription) {
						this.$store.commit("setFromSubscription", false)
						this.$router.push(`/users/user/${res.data.data[0].id}?actionFrom=user-subscription`)
					}
				} else {
					this.showAPIErrorToast("Unable to fetch user list.", res)
				}
				this.isAPILoading = false
			})
		},
		toggleUserStatus(event, user) {
			let flag = event.target.checked
			const alertTitle = `${flag ? "Activate" : "Deactivate"} User`
			const alertMsg = `Are you sure you want to ${flag ? "activate" : "deactivate"} user?`

			this.$swal({
				title: alertTitle,
				text: alertMsg,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				showCloseButton: true
			}).then((result) => {
				if (result.value) {
					this.callUserStatusToggleAPI(user.id, flag, event)
				} else {
					event.target.checked = !flag
				}
			})
		},
		callUserStatusToggleAPI(userId, flag, event) {
			const handleResponse = (res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.showCustomSuccessToast(`Successfully ${flag ? "activated" : "deactivated"} user`)
					this.getTableContent();
					event.target.checked = flag
				} else {
					this.showAPIErrorToast(`Unable to ${flag ? "reactivate" : "deactivate"} user.`, res)
					event.target.checked = !flag
				}
			}

			const handleCatch = () => {
				this.showGenericErrorToast()
				event.target.checked = !flag
			}

			const userDetails = {
				status: flag ? "A" : "I",
			}

			UserService.updateUserStatus(userId, userDetails).then(handleResponse).catch(handleCatch)
		},
		preFilterPetTable(user) {
			this.$emit("setPetFilters", user.emailAddress)
		},
		userRole(role) {
			return USER_TYPE[role]
		},
		reinstateUser(user) {
			const { firstName, lastName } = user

			this.$swal({
				title: "Reactivate User",
				text: `Are you sure you want to reactivate ${firstName} ${lastName}?`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				showCloseButton: true
			}).then(async (result) => {
				if (result.value) {
					const handleResponse = (res) => {
						console.log(res)
						if (res.status === STATUS_CODES.SUCCESS) {
							this.callResendActivationLink(user)
						} else {
							this.showAPIErrorToast(`Unable to reactivate this user.`, res)
						}
					}

					const handleCatch = () => {
						this.showGenericErrorToast()
					}
					await UserService.updateUserStatus(user.id, { status: "P" }).then(handleResponse).catch(handleCatch)
				}
			})
		},
		resendActivationLink(user) {
			const { firstName, lastName } = user

			this.$swal({
				title: "Resend Activation Link",
				text: `Are you sure you want to resend activation link to email ${firstName} ${lastName}?`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				showCloseButton: true
			}).then((result) => {
				if (result.value) {
					this.callResendActivationLink(user)
				}
			})
		},
		async redirectToBreeder(user) {
			await breederService.getBreederById(user.id).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.$router.push(`/breeder-management/${res.data.data[0].id}/view`);
				}	
			})
		},
		callResendActivationLink(user) {
			const { firstName, lastName, emailAddress } = user
			const handleResponse = (res) => {
				if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					this.showCustomSuccessToast(`Successfully send reactivation link to ${firstName} ${lastName}`)
				} else {
					this.showAPIErrorToast(`Unable to send reactivation link`, res)
				}
			}

			const handleCatch = () => {
				this.showGenericErrorToast()
			}

			UserService.resendLink(emailAddress).then(handleResponse).catch(handleCatch)
		},
	},
}

